/** Client-side document upload rules (mirror of API documentSecurity). */

export const DOC_MAX_BYTES = 10 * 1024 * 1024; // 10 MB
export const DOC_ACCEPT = '.pdf,.png,.jpg,.jpeg,application/pdf,image/png,image/jpeg';
export const DOC_ALLOWED_EXT = new Set(['.pdf', '.png', '.jpg', '.jpeg']);

export function documentExtension(fileName) {
  const base = String(fileName || '').split(/[/\\]/).pop() || '';
  const i = base.lastIndexOf('.');
  if (i < 0) return '';
  return base.slice(i).toLowerCase();
}

/**
 * @returns {{ ok: true } | { ok: false, error: string }}
 */
export function validateDocumentFileClient(file) {
  if (!file) return { ok: false, error: 'Select a file' };
  const name = String(file.name || 'document');
  const ext = documentExtension(name);
  if (!DOC_ALLOWED_EXT.has(ext)) {
    return {
      ok: false,
      error: 'Only PDF, PNG, and JPG files are allowed (ZIP and other formats are blocked)',
    };
  }
  if (/\.(zip|rar|7z|exe|dll|js|vbs|bat|cmd|ps1|scr|msi)(\.|$)/i.test(name.slice(0, -ext.length))) {
    return { ok: false, error: 'File name looks like a disguised archive or executable' };
  }
  if (file.size <= 0) return { ok: false, error: 'File is empty' };
  if (file.size > DOC_MAX_BYTES) {
    return { ok: false, error: `File exceeds the ${DOC_MAX_BYTES / (1024 * 1024)}MB limit` };
  }
  const mime = String(file.type || '').toLowerCase();
  if (
    mime &&
    mime !== 'application/octet-stream' &&
    !['application/pdf', 'image/png', 'image/jpeg', 'image/jpg'].includes(mime)
  ) {
    return { ok: false, error: 'Content type must be PDF, PNG, or JPEG' };
  }
  return { ok: true };
}
